import React from 'react'

import { TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import EmailSuggestion from 'Pods/Shared/EmailSuggestion/EmailSuggestion'
import i18n from 'Pods/Shared/I18n'

function EmailField({ value, locale = 'en', onChange }) {
  const t = key => i18n.t(`auth_modal.${key}`, { ns: 'rails', lng: locale })
  // The parent hook reads event.target.value, so accepting a suggestion
  // forwards a minimal event-shaped object instead of a real DOM event.
  const handleAcceptSuggestion = (suggested) => {
    onChange({ target: { value: suggested } })
    document.getElementById('sign-in-email')?.focus()
  }

  return (
    <>
      <TextInput
        id="sign-in-email"
        type="primary"
        size="medium"
        label={t('email_label')}
        placeholder={t('email_placeholder')}
        value={value}
        onChange={onChange}
        wrapperClassName="auth-modal__field"
        aria-label={t('email_aria_label')}
        autoFocus
        isPilot
      />
      <EmailSuggestion
        email={value}
        onAccept={handleAcceptSuggestion}
        className="auth-modal__email-suggestion"
      />
    </>
  )
}

EmailField.propTypes = {
  value: string.isRequired,
  locale: string,
  onChange: func.isRequired,
}

export default EmailField
